import { Component } from "react";
import PropTypes from "prop-types";
import styles from "./speech-bubble-product-listing.module.less";
import { extract } from "@parksandresorts/core";

export default class SpeechBubbleProductListing extends Component {
  static propTypes = {
    poisitionOver: PropTypes.bool,
    bubbleBelongsTo: PropTypes.string,
    speechBubbleInverseColors: PropTypes.bool,
    componentTheme: PropTypes.string,
    title: PropTypes.string,
  };

  constructor(props) {
    super(props);
    this.imageInBubble = extract(props, "imageInBubble.file.url");
    this.title = extract(props, "title");
    this.componentTheme = extract(props, "componentTheme");
    this.speechBubbleInverseColors = extract(props, "speechBubbleInverseColors");
    this.speechBubbleLink = extract(props, "speechBubbleLink.internalLink.slug");
    this.extraClasses = extract(props, "extraClasses");
    this.link = this.speechBubbleLink ? this.speechBubbleLink : this.props.externalUrl;
    this.enableBubbleArrowDesktop = extract(props, "enableBubbleArrowDesktop");
  }

  render() {
    return (
      <div className={this.componentTheme ? `component-theme-${this.componentTheme}` : ""}>
        <div
          className={[
            this.speechBubbleInverseColors ? styles.inverseColors : "",
            styles.wrapper,
            this.extraClasses ? this.extraClasses : "",
            this.enableBubbleArrowDesktop ? "" : styles.disableArrowDesktop,
          ].join(" ")}
        >
          {this.title && (
            <div className={styles.headlineWrapper}>
              <p className={styles.headline}>{this.title}</p>
            </div>
          )}
        </div>
      </div>
    );
  }
}
